import { Motorcycle } from "@pmag/icons";
import { Typography } from "@pmag/ui-components";
import { type FunctionComponent } from "react";
import { useIntl } from "react-intl";

import { ChipContainer } from "./CountChip.styles";

export const dataTestId = {
    container: "sparePartsFinder.components.countChip.container",
};

interface CountChipProps {
    count: number;
    description?: string;
}

export const CountChip: FunctionComponent<CountChipProps> = ({ count, description, ...restProps }) => {
    const intl = useIntl();

    const descriptionText =
        description ??
        intl.formatMessage(
            {
                id: "sparePartsFinder.countChip.options",
                defaultMessage: "{count, plural, =1 {option} other {options}}",
            },
            { count },
        );

    return (
        <ChipContainer {...restProps}>
            <Motorcycle size="small" />

            <Typography variant="label-01">{`${count} ${descriptionText}`}</Typography>
        </ChipContainer>
    );
};
